import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DocumentInterface } from '../data';
import { DocumentProvider } from '../providers/document.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface RemoveDocumentUseCaseParams {
    document: DocumentInterface;
}

@Injectable()
export class RemoveDocumentUseCase implements UseCaseWithParam<RemoveDocumentUseCaseParams, Observable<Transaction<void>>> {
    constructor(private documentProvider: DocumentProvider) {}

    bind(params: RemoveDocumentUseCaseParams): Observable<Transaction<void>> {
        return this.documentProvider.remove(params.document);
    }
}
